import constants from '../constants';
import { EditableType, EditorType } from '../../../constants';
import * as helpers from '../../helpers';
import { IndesignMediaElementConfig, MediaElementDataAttribute } from './getData';
import { MediaElement } from '../../editableMedia/typing';
import { isIframe, getDriveLinkWithoutHash, getElement, setTooltipActions } from '../../editableMedia/saveData';

interface StyleData {
	width: number;
	height: number;
	x: number;
	y: number;
}

const setStyle = (element: MediaElement, { width, height, x, y }: StyleData): void => {
	const style = `width:${width}px;height:${height}px;transform:translate(${x}px, ${y}px);-webkit-transform:translate(${x}px, ${y}px)`;
	element.setAttribute('style', style);
};

const setElementContent = (
	htmlDocument: Document,
	element: MediaElement,
	id: string,
	type: EditableType,
	isExternalLinkActive: boolean,
	isVisible?: boolean
): void => {
	const frame = htmlDocument.querySelector(`#${id}`) as HTMLElement;
	helpers.setElementIsEdited(frame);

	frame.innerHTML = '';

	if (!isVisible) {
		frame.style.pointerEvents = 'none';
	} else {
		frame.style.removeProperty('pointer-events');
	}

	if (isIframe(type, isExternalLinkActive)) {
		// tslint:disable-next-line: max-line-length
		// when embed Youtube video, inline-style 'transform: scale(0.99)' is set for iframe parent element in Safari (it seems that it comes from Reader code). It breaks correct position of iframe parent element. To fix it we have to add element between iframe and its parent element (object element is added because Reader has already correct styles for this element)
		const object = htmlDocument.createElement('object');
		object.className = constants.videoOrIframeWrapperId;
		object.appendChild(element);
		frame.appendChild(object);
	} else {
		frame.appendChild(element);
	}
};

export default (htmlDocument: Document, mediaItems: IndesignMediaElementConfig[], isAccessible?: boolean): void => {
	mediaItems.forEach(({
		isEditedFromBackoffice,
		type,
		id,
		className,
		defaultLink,
		driveLink,
		externalLink,
		isExternalLinkActive,
		width,
		height,
		x,
		y,
		label,
		defaultLabel,
		tooltip,
		isTooltipActive,
		videoSettings,
		isVisible,
		originalStyle,
	}) => {
		if (!isEditedFromBackoffice) {
			return;
		}

		const modifiedDriveLink = getDriveLinkWithoutHash(driveLink);
		const src = (isExternalLinkActive ? externalLink : modifiedDriveLink) || defaultLink;
		const element = getElement(EditorType.INDESIGN, type, isExternalLinkActive, htmlDocument, src, videoSettings, isVisible, className);

		const isCustomLink = (src !== defaultLink) || (isExternalLinkActive && !!modifiedDriveLink);

		if (isAccessible && type === EditableType.image && originalStyle) {
			element.setAttribute('style', originalStyle);
		} else if (type === EditableType.image && isCustomLink) {
			setStyle(element, { width, height, x, y });
		}

		if (isCustomLink) {
			helpers.setDataAttributes(element, {
				[MediaElementDataAttribute.edited]: true,
				[MediaElementDataAttribute.label]: isExternalLinkActive ? '' : label,
				[MediaElementDataAttribute.defaultLabel]: defaultLabel,
				[MediaElementDataAttribute.defaultLink]: defaultLink,
				[MediaElementDataAttribute.driveLink]: modifiedDriveLink,
				[MediaElementDataAttribute.externalLink]: externalLink,
				[MediaElementDataAttribute.externalLinkActive]: isExternalLinkActive,
				[MediaElementDataAttribute.tooltip]: tooltip,
				[MediaElementDataAttribute.tooltipActive]: isTooltipActive,
				[MediaElementDataAttribute.hidden]: !isVisible,
			});
		} else {
			helpers.setDataAttributes(element, {
				[MediaElementDataAttribute.label]: defaultLabel,
			});

			if (!isVisible) {
				helpers.setDataAttributes(element, {
					[MediaElementDataAttribute.hidden]: true,
					[MediaElementDataAttribute.defaultLink]: defaultLink,
				});
			}
		}

		setTooltipActions(element, tooltip, isTooltipActive);
		setElementContent(htmlDocument, element, id, type, isExternalLinkActive, isVisible);
	});
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/utils/indesignEditor/editableMedia/saveData.ts